// @flow

import { applyMiddleware } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';

import rootReducer from './reducers/index';

export default (configureStore(
    { reducer: rootReducer }
): any)